import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../constants';

import { SubNav } from './SubNav';

export default ({ sub, subId, userId, detailsInfo, contracts, isAdmin }) => (
  <div className="Sub">
    <div className="flex-justify-space-between">
      <h1>Tracfone Subscription details</h1>
      <Link
        to={`/users/${userId}/purchases?subscription=${subId}&subCarrier=tracfone`}
      >
        Subscription purchases
      </Link>
    </div>
    <SubNav sub={sub} />
    <table className="table">
      <tbody>
        <tr>
          <td>ID</td>
          <td>{sub.id}</td>
          <td></td>
        </tr>
        <tr>
          <td>User Profile ID</td>
          <td>{sub.user_profile}</td>
          <td></td>
        </tr>
        <tr>
          <td>First Name</td>
          <td>{sub.first_name}</td>
          <td></td>
        </tr>
        <tr>
          <td>Last Name</td>
          <td>{sub.last_name}</td>
          <td></td>
        </tr>
        <tr>
          <td>MDN</td>
          <td>{sub.mdn}</td>
          <td></td>
        </tr>
        <tr>
          <td>Device ID</td>
          <td>{sub.device_id}</td>
          <td></td>
        </tr>
        <tr>
          <td>ICC ID</td>
          <td>{sub.icc_id}</td>
          <td></td>
        </tr>
        <tr>
          <td>TracFone Status</td>
          <td>{sub.tracfone_status}</td>
          <td></td>
        </tr>
        <tr>
          <td>Synced With TracFone</td>
          <td>{String(sub.synced_with_tracfone)}</td>
          <td></td>
        </tr>
        {sub.running_action && (
          <tr className="red-text">
            <td>Running Action</td>
            <td colSpan="2">
              {sub.running_action.action_type && (
                <span> Action type: {sub.running_action.action_type} | </span>
              )}
              {sub.running_action.action_start_date && (
                <span>
                  {' '}
                  Start date:{' '}
                  {moment(sub.running_action.action_start_date).format(
                    DATE_TIME_FORMAT,
                  )}
                </span>
              )}
            </td>
          </tr>
        )}
        <tr>
          <td>Sub carrier</td>
          <td>{sub.sub_carrier}</td>
          <td></td>
        </tr>
        <tr>
          <td>Effective Date</td>
          <td>
            {sub.effective_date
              ? moment(sub.effective_date).format(DATE_TIME_FORMAT)
              : sub.effective_date}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Expiry Date</td>
          <td>
            {sub.expiry_date
              ? moment(sub.expiry_date).format(DATE_TIME_FORMAT)
              : sub.expiry_date}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Expiry Type</td>
          <td>{sub.expiry_type}</td>
          <td></td>
        </tr>
        <tr>
          <td>Renew at</td>
          <td>
            {sub.renew_at
              ? moment(sub.renew_at).format(DATE_TIME_FORMAT)
              : sub.renew_at}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>TF Renewal Date</td>
          <td>
            {sub.tf_renewal_date
              ? moment(sub.tf_renewal_date).format(DATE_TIME_FORMAT)
              : sub.tf_renewal_date}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>PIN</td>
          <td>{sub.pin}</td>
          <td></td>
        </tr>
        <tr>
          <td>Activation Type</td>
          <td>{sub.activation_type}</td>
          <td></td>
        </tr>
        <tr>
          <td>Suspension Type</td>
          <td>{sub.suspension_type}</td>
          <td></td>
        </tr>
        <tr>
          <td>Plan</td>
          <td>
            {sub.plan && (
              <span>
                {sub.plan.name}
                {' - '}${sub.plan.price}
                {' | '}
                Data available: {sub.plan.data_available}MB
                {' | '}
                Type: {sub.plan.plan_type && sub.plan.plan_type.toString()}
              </span>
            )}
          </td>
        </tr>
        <tr>
          <td>Upcoming Plan</td>
          <td>
            {sub.upcoming_plan && (
              <span>
                {sub.upcoming_plan.name}
                {' - '}${sub.upcoming_plan.price}
                {' | '}
                Data available: {sub.upcoming_plan.data_available}MB
                {' | '}
                Type:{' '}
                {sub.upcoming_plan.plan_type &&
                  sub.upcoming_plan.plan_type.toString()}
              </span>
            )}
          </td>
        </tr>
        {detailsInfo && sub.plan.plan_type === 'Unlimited' && (
          <tr>
            <td>TracFone Plan</td>
            <td>
              {detailsInfo.tracfone_plan.id} |{' '}
              {detailsInfo.tracfone_plan.description}
            </td>
            <td></td>
          </tr>
        )}
        <tr>
          <td>Agent ID</td>
          <td>{sub.agent_id}</td>
          <td></td>
        </tr>
        <tr>
          <td>Agent Name</td>
          <td>{sub.agent_name}</td>
          <td></td>
        </tr>
        <tr>
          <td>Device Status</td>
          <td>{sub.device_status}</td>
          <td></td>
        </tr>
        <tr>
          <td>MSID</td>
          <td>{sub.msid}</td>
          <td></td>
        </tr>
        <tr>
          <td>Deleted</td>
          <td>{String(sub.deleted)}</td>
          <td></td>
        </tr>
        <tr>
          <td>Device Protection Contracts</td>
          <td>
            {contracts &&
              contracts.map((contract) => {
                return (
                  <Link
                    className="mar-r"
                    key={contract.id}
                    to={`/device-protection/contracts/${contract.id}/view`}
                  >
                    ID: {contract.id}
                  </Link>
                );
              })}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Created By</td>
          <td>{sub.created_by}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
);
